import gql from 'graphql-tag';
import { PRODUCT_ARRANGEMENT_PRODUCT_FRAGMENT, PRODUCT_ARRANGEMENT_WITH_PRODUCTS_FRAGMENT } from './productArrangement';

export const MICROSTORE_COLUMN_TEMPLATE_FRAGMENT = gql`
    fragment MicrostoreColumnTemplateFragment on MicrostoreColumnTemplate {
        _id
        name
        type
        state
    }
`;

export const MICROSTORE_COLUMN_TEMPLATE_WITH_ALL_INFO = gql`
    fragment MicrostoreColumnTemplateWithAllInfo on MicrostoreColumnTemplate {
        _id
        name
        type
        state
        shelfTemplates {
            _id
            columnTemplateId
            locationTemplateTable {
                _id
                positionInShelf {
                    column
                    row
                }
                productArrangement {
                    ...ProductArrangementWithProductsFragment
                }
                alternativeProductArrangementIds
                product {
                    ...ProductArrangementProductFragment
                }
                stockMax
                reassortmentType
                shelfTemplateId
                shouldOrderProductIfNotInSite
                shouldSmoothProductTransition
                allowProductRotation
                trayMaxCapacity
            }
            positionInColumn
        }
    }
    ${PRODUCT_ARRANGEMENT_WITH_PRODUCTS_FRAGMENT}
    ${PRODUCT_ARRANGEMENT_PRODUCT_FRAGMENT}
`;
